import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  modalWrapper: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      gap: SPACES.m,

      padding: SPACES.xxxxl,

      [theme.breakpoints.down('tablet')]: {
        minWidth: 300,
        maxWidth: 'calc(100vw - 32px)',
      },
      [theme.breakpoints.up('tablet')]: {
        width: 500,
      },
    },
  },
  form: {
    width: '100%',
    height: '100%',
    flex: 1,

    display: 'flex',
    flexDirection: 'column',
    gap: SPACES.xxxl,
  },
  submitWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  radioLabel: {
    '&&': {
      lineHeight: 1.33,

      color: theme.palette.custom.grey2,

      [theme.breakpoints.down('tablet')]: {
        fontSize: FONTS.SIZES.s,
        fontWeight: FONTS.WEIGHTS.light,
      },
      [theme.breakpoints.up('tablet')]: {
        fontSize: FONTS.SIZES.xs,
        fontWeight: FONTS.WEIGHTS.medium,
      },
    },
  },

  searchIcon: {
    width: 30,
    height: 30,
    marginRight: 10,
  },
}))
